import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import SVG from "react-inlinesvg";
import { Badge } from "react-bootstrap";
import { getNotificationBadge } from "../../../../_helpers/DashboardRequests";

const AsideMenuItem = ({ text, getMenuItemActive, icon, url, badge }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [isOrderPage, setIsOrderPage] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (badge) {
      getNotificationCount();
    }
  }, []);

  useEffect(() => {
    const body = document.body.classList.contains("aside-minimize");

    if (location.pathname === "/sales/orders/new") {
      // document.body.classList.add("sales-order-new");
      setIsOrderPage(true);
    } else {
      // document.body.classList.remove("sales-order-new");
      setIsOrderPage(false);
    }
  }, [location.pathname]);

  const getNotificationCount = () => {
    getNotificationBadge(badge)
      .then((resp) => {
        setNotificationCount(resp.data.count);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <li
      className={`menu-item ${getMenuItemActive}`}
      aria-haspopup="true"
      role="button"
    >
      <NavLink className="menu-link" to={url}>
        <span className="svg-icon menu-icon">
          <SVG src={icon} />
        </span>
        <span className="menu-text">{text}</span>
        {badge && !isLoading && notificationCount > 0 && (
          <Badge
            pill
            variant="danger"
            className={`d-flex align-items-center justify-content-center w-20px h-20px`}
            style={{ transform: "translateX(14px) translateY(-4px)" }}
          >
            {notificationCount}
          </Badge>
        )}
      </NavLink>
    </li>
  );
};

export default AsideMenuItem;
